import type { Location } from "react-router-dom";
import type { PathologistQueueViewTab } from "./pathologistQueueViewPreference";

export interface PathologistQueueReturnState {
  pathologistQueueReturnTo: string;
}

const RETURN_ROUTES: Record<PathologistQueueViewTab, string> = {
  review: "/pathologist-review",
  sentOut: "/pathologist-review?tab=sentOut",
  incoming: "/pathologist-review?tab=incoming",
  all: "/pathologist-review?tab=all",
  completed: "/pathologist-review?tab=completed",
  corrections: "/pathologist-review?tab=corrections",
};

export function createPathologistQueueReturnState(
  tab: PathologistQueueViewTab
): PathologistQueueReturnState {
  return { pathologistQueueReturnTo: RETURN_ROUTES[tab] };
}

export function getPathologistQueueReturnTo(
  location: Pick<Location, "state">
): string {
  const state = location.state as Partial<PathologistQueueReturnState> | null;
  return state?.pathologistQueueReturnTo &&
    Object.values(RETURN_ROUTES).includes(state.pathologistQueueReturnTo)
    ? state.pathologistQueueReturnTo
    : "/pathologist-review";
}
